import React from "react";

const AwaitingApproval = ({
  isAwaitingApprovalOpen,
  closeAwaitingApproval,
}) => {
  if (!isAwaitingApprovalOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50 p-4 backdrop-blur-sm overflow-y-auto">
      {/* Kept 670px width and min-height structure */}
      <div className="bg-white rounded-md shadow-xl w-full max-w-[670px] min-h-[340px] my-auto p-6 sm:p-8 md:p-10 flex flex-col items-center justify-center text-center transition-all">
        {/* Icon Container */}
        <div className="mb-5 sm:mb-6 flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-blue-100 shrink-0">
          <div className="bg-blue-100 p-2 sm:p-3 rounded-full">
            <img
              src="/blue-tick.png"
              alt="Awaiting Approval"
              className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
            />
          </div>
        </div>

        {/* Text Content */}
        <div className="w-full max-w-[500px] px-2">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 break-words">
            Loan Application Successful!
          </h2>
          <p className="text-gray-600 text-xs sm:text-sm mb-6 leading-relaxed break-words">
            The loan application has been submitted successfully and is now
            pending approval.
          </p>
        </div>

        {/* Action Button */}
        <button
          onClick={closeAwaitingApproval}
          className="w-full sm:w-auto min-w-[180px] bg-[#074073] hover:bg-[#052f5a] text-white py-2.5 sm:py-2 px-8 rounded-md font-medium text-sm transition-colors duration-150"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default AwaitingApproval;
